<template>
    <div id="planning_kecamatan" >

<section class="content">
<div class="container-fluid">

    <div class="row clearfix">

        <div class="bg-light-green" style="margin-top:-1% !important;">
            <!-- <br> -->
            <div class="row paddingku">
                <div class="col-md-3 searching">
                    <span class="h_page">Diklat Fungsional</span> <br> <br>
                </div>
                <div class="col-md-6">

                </div>
                <div class="col-md-3 searching">
                    <div class="input-group">
                        <span class="input-group-btn">
                            <button @click="check_add()" type="button" class="btn bg-light-blue btn-sm waves-effect" title="Tambah Data" data-toggle="modal" data-target="#m_tambah_data" disabled><i class="material-icons">add</i></button>
                        </span>
                        <input @keyup="cari_data()" v-model="cari_value" type="text" class="form-control" placeholder="Cari data" id="caridata" >

                    </div> <br>
                </div>
            </div>
        </div>


        <div class="col-xs-12 card">
    <!-- ============================================================ MULAI ======================================================================== -->

        <br>
            <div class="row">
<!-- <div id="people"></div> -->
                

                <div class="col-md-6">
   
                    <span class="huruf_input">Unit Kerja</span>
                    <autocomplete
                        :url="URL+ 'api/v1/simpeg_unit_kerja/autocomplete'"
                        :customHeaders="{authorization: 'kikensbatara '+token }"
                        anchor="unit_kerja"
                        :initValue="''"
                        :placeholder="unit_kerja_full"
                        :classes="{ input: 'form-control'}"
                        label="writer"
                        :onShouldRenderChild="renderChild"
                        :on-select="getAuto">
                    </autocomplete>
                    
                    

                </div>
                <div class="col-md-6">
                    
                </div>

            </div>
        <br>

            <div class="table-responsive">
                <table class="table table-bordered" style="width: 100%">
                    <thead>
                    <tr class="bg-success">
                        <th style="width: 5%" class="text-center">No.</th>
                        <th style="width: 20%" class="text-center">Nama</th>
                        <th style="width: 20%" class="text-center">NIP</th>
                        <th style="width: 40%" class="text-center">Jabatan</th>
                        <th style="width: 15%" class="text-center"></th>
                    </tr>
                    </thead>
                    <tbody>
                        <!-- track-by="data.createdtime" -->
                        <tr class="h_isitable" v-for="(data, index) in list_data" :key="data.id">
                            <td class="text-center">{{index+1}}</td>
                            <td>{{check_gelar_depan(data.gelar_depan)}}{{data.nama}}{{check_gelar_belakang(data.gelar_belakang)}}</td>
                            <td class="text-center">{{data.nip}}</td>
                            <td>{{data.nm_jabatan}}</td>
                            <td class="text-center" >
                                <button @click="selectData(data)" class="btn bg-light-blue btn-xs waves-effect" title="Lihat Detil Profil Pegawai" data-toggle="modal" data-target="#m_lihat_data">
                                    <i class="material-icons" >search</i>
                                </button>
                                    &nbsp;
                                <button @click="selectData(data)" class="btn bg-light-green btn-xs waves-effect" title="Tambah Riwayat Pendidikan" data-toggle="modal" data-target="#m_list_data">
                                    <i class="material-icons" >layers</i>
                                </button>
                            </td>
                        </tr>

                    </tbody>
                </table>
            </div>

            <hr>
                <div class="text-center">
                    <button @click="btn_prev" type="button" class="btn btn-xs bg-blue waves-effect" id="pref">
                        <i class="material-icons">skip_previous</i>
                    </button>
                    &nbsp;
                    <span style="font-size: 85%; color: #a5a5a5">
                        <b>{{page_first}} - {{page_last}}</b>
                    </span>
                    &nbsp;
                    <button @click="btn_next" type="button" class="btn btn-xs bg-blue waves-effect" id="next">
                        <i class="material-icons">skip_next</i>
                    </button>
                </div>
            <hr>
            <!-- ============================================================ MODAL ======================================================================== -->


                

                <!-- xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx MODAL LIHAT xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx -->
                    <div class="modal fade" id="m_lihat_data" tabindex="-1" role="dialog">
                        <div class="modal-dialog modal-lg" role="document">
                            <div class="modal-content">
                                <div class="modal-header bg-light-blue">
                                    <button @click="emptyData()" type="button" class="close" data-dismiss="modal" aria-label="Close">
                                        <span aria-hidden="true">&times;</span></button>
                                    <h4 class="modal-title" id="largeModalLabel">LIHAT DATA</h4>
                                </div>
                                <div class="modal-body">
                                    <div class="table-responsive">
                                        <table class="table table-bordered" style="width: 100%">
                                            <thead>
                                                <tr class="h_isitable text-center">
                                                    <th class="text-center" colspan="3">
                                                        <img :src="file_path+form.file" width="30%">
                                                    </th>
                                                </tr>
                                                <tr class="bg-info">
                                                    <th style="width: 5%" class="text-center">No.</th>
                                                    <th style="width: 35%" class="text-center">Index</th>
                                                    <th style="width: 60%" class="text-center">Uraian</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <!-- track-by="data.createdtime" -->
                                                

                                                <tr class="h_isitable">
                                                    <td class="text-center">1.</td>
                                                    <td>Unit Kerja</td>
                                                    <td>{{nm_unit_kerja}}</td>
                                                </tr>
                                                <tr class="h_isitable">
                                                    <td class="text-center">2.</td>
                                                    <td>Nama</td>
                                                    <td>{{check_gelar_depan(form.gelar_depan)}} {{form.nama}}{{ check_gelar_belakang(form.gelar_belakang)}}</td>
                                                </tr>
                                                <tr class="h_isitable">
                                                    <td class="text-center">3.</td>
                                                    <td>NIP</td>
                                                    <td>{{form.nip}}</td>
                                                </tr>

                                                <tr class="h_isitable">
                                                    <td class="text-center">4.</td>
                                                    <td>Jabatan</td>
                                                    <td>{{nm_jabatan}}</td>
                                                </tr>
                                                <tr class="h_isitable">
                                                    <td class="text-center">5.</td>
                                                    <td>Tempat, Tanggal Lahir</td>
                                                    <td>{{form.tempat_lahir}}, {{form.ttl}}</td>
                                                </tr>
                                                <tr class="h_isitable">
                                                    <td class="text-center">6.</td>
                                                    <td>Jenis Kelamin</td>
                                                    <td>{{form.jenis_kelamin}}</td>
                                                </tr>
                                                <tr class="h_isitable">
                                                    <td class="text-center">7.</td>
                                                    <td>Status Keluarga</td>
                                                    <td>{{form.status_keluarga}}</td>
                                                </tr>
                                                <tr class="h_isitable">
                                                    <td class="text-center">8.</td>
                                                    <td>Agama</td>
                                                    <td>{{form.agama}}</td>
                                                </tr>
                                                <tr class="h_isitable">
                                                    <td class="text-center">9.</td>
                                                    <td>Pendidikan Terahir</td>
                                                    <td>{{form.pendidikan_ahir}}</td>
                                                </tr>
                                                <tr class="h_isitable">
                                                    <td class="text-center">10.</td>
                                                    <td>Nama Sekolah</td>
                                                    <td>{{form.sekolah}}</td>
                                                </tr>

                                                <tr class="h_isitable">
                                                    <td class="text-center">11.</td>
                                                    <td>Tahun Lulus</td>
                                                    <td>{{form.thn_lulus}}</td>
                                                </tr>
                                                <tr class="h_isitable">
                                                    <td class="text-center">12.</td>
                                                    <td>TMT CPNS</td>
                                                    <td>{{form.tmt_cpns}}</td>
                                                </tr>
                                                <tr class="h_isitable">
                                                    <td class="text-center">13.</td>
                                                    <td>Golongan</td>
                                                    <td>{{form.gol}}</td>
                                                </tr>
                                                <tr class="h_isitable">
                                                    <td class="text-center">14.</td>
                                                    <td>TMT Golongan</td>
                                                    <td>{{form.tmt_golongan}}</td>
                                                </tr>
                                                <tr class="h_isitable">
                                                    <td class="text-center">15.</td>
                                                    <td>Nomor Karpeg</td>
                                                    <td>{{form.no_karpeg}}</td>
                                                </tr>
                                                <tr class="h_isitable">
                                                    <td class="text-center">16.</td>
                                                    <td>Kepemilikan Taspen</td>
                                                    <td>{{form.taspen}}</td>
                                                </tr>
                                                <tr class="h_isitable">
                                                    <td class="text-center">17.</td>
                                                    <td>Nomor NPWP</td>
                                                    <td>{{form.NPWP}}</td>
                                                </tr>
                                                <tr class="h_isitable">
                                                    <td class="text-center">18.</td>
                                                    <td>Alamat</td>
                                                    <td>{{form.alamat}}</td>
                                                </tr>
                                                <tr class="h_isitable">
                                                    <td class="text-center">19.</td>
                                                    <td>Kota / Kode POS</td>
                                                    <td>Kota : {{form.kota_asal}}, Kode POS :{{form.kode_pos}}</td>
                                                </tr>
                                                <tr class="h_isitable">
                                                    <td class="text-center">20.</td>
                                                    <td>Nomor Kontak</td>
                                                    <td>{{form.kontak}}</td>
                                                </tr>

                                            </tbody>
                                        </table>
                                    </div>

                                </div>
                                <div class="modal-footer">
                                    <!-- <button type="submit" class="btn btn-success waves-effect">RUBAH</button> -->
                                    <button @click="emptyData()" type="button" class="btn btn-danger waves-effect" data-dismiss="modal">KEMBALI</button>
                                </div>
                            </div>
                        </div>
                    </div>
                <!-- xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx MODAL LIHAT xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx -->

                <!-- xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx MODAL LIST PENDIDIKAN xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx -->
                    <div class="modal fade" id="m_list_data" tabindex="-1" role="dialog">
                        <div class="modal-dialog modal-lg" role="document">
                            <div class="modal-content">
                                <div class="modal-header bg-light-green">
                                    <button @click="emptyData()" type="button" class="close" data-dismiss="modal" aria-label="Close">
                                        <span aria-hidden="true">&times;</span></button>
                                    <h4 class="modal-title" id="largeModalLabel">DETIL PENDIDIKAN </h4>
                                </div>
                                <div class="modal-body">
                                    <div class="table-responsive">

                                        <button class="btn btn-sm bg-light-green"  data-toggle="modal" data-target="#m_tambah_data">TAMBAH</button>
                                        <hr>

                                        <div class="panel-group" id="accordion_1" role="tablist" aria-multiselectable="true">
                                            <div class="panel  bg-light-green" v-for="data in list_pendidikan" :key="data.diklat_fungsional_id">
                                                <div class="panel-heading" role="tab" :id="'x'+data.diklat_fungsional_id">
                                                    <h4 class="panel-title">
                                                        <a role="button" data-toggle="collapse" data-parent="#accordion_1" :href="'#'+data.diklat_fungsional_id" aria-expanded="false" aria-controls="collapseOne_1" class="collapsed">
                                                            {{data.nm_diklat}}
                                                        </a>
                                                    </h4>
                                                </div>
                                                <div :id="data.diklat_fungsional_id" class="panel-collapse collapse" role="tabpanel" :aria-labelledby="'x'+data.diklat_fungsional_id" aria-expanded="false" style="height: 0px;">
                                                    <div class="panel-body" style="background:white">
                                                        <div class="table-responsive">
                                                            <table class="table table-bordered" style="width: 100%">
                                                                <thead>
                                                                    <tr class="h_isitable text-center">
                                                                        <th class="text-center" colspan="3">
                                                                            <button @click="selectPendidikan(data)" class="btn btn-sm bg-light-blue" data-toggle="modal" data-target="#m_lihat_lampiran" title="Lihat Data Lampiran">
                                                                                <i class="material-icons">attach_file</i>
                                                                            </button>
                                                                            &nbsp;
                                                                            <button @click="selectPendidikan(data)" class="btn btn-sm bg-orange" data-toggle="modal" data-target="#m_edit_data"  title="Edit Data">
                                                                                <i class="material-icons">create</i>
                                                                            </button>
                                                                            &nbsp;
                                                                            <button @click="removeData(data.diklat_fungsional_id, data.file)" class="btn btn-sm bg-red" title="Hapus Data">
                                                                                <i class="material-icons">clear</i>
                                                                            </button>
                                                                        </th>
                                                                    </tr>
                                                                    <tr class="bg-info">
                                                                        <th style="width: 5%" class="text-center">No.</th>
                                                                        <th style="width: 35%" class="text-center">Index</th>
                                                                        <th style="width: 60%" class="text-center">Uraian</th>
                                                                    </tr>
                                                                </thead>
                                                                <tbody>
                                                                    <!-- track-by="data.createdtime" -->
                                                                    <tr class="h_isitable">
                                                                        <td class="text-center">1.</td>
                                                                        <td>NAMA DIKLAT</td>
                                                                        <td>{{data.nm_diklat}}</td>
                                                                    </tr>
                                                                    <tr class="h_isitable">
                                                                        <td class="text-center">2.</td>
                                                                        <td>TEMPAT BELAJAR</td>
                                                                        <td>{{data.tpt_belajar}}</td>
                                                                    </tr>
                                                                    <tr class="h_isitable">
                                                                        <td class="text-center">3.</td>
                                                                        <td>LOKASI</td>
                                                                        <td>{{data.lokasi_pendidikan}}</td>
                                                                    </tr>
                                                                    <tr class="h_isitable">
                                                                        <td class="text-center">4.</td>
                                                                        <td>TANGGAL MULAI</td>
                                                                        <td>{{split_date(data.tgl_mulai)}}</td>
                                                                    </tr>
                                                                    
                                                                    <tr class="h_isitable">
                                                                        <td class="text-center">5.</td>
                                                                        <td>TANGGAL SELESAI</td>
                                                                        <td>{{split_date(data.tgl_selesai)}}</td>
                                                                    </tr>
                                                                    <tr class="h_isitable">
                                                                        <td class="text-center">6.</td>
                                                                        <td>JUMLAH JAM</td>
                                                                        <td>{{data.jumlah_jam}}</td>
                                                                    </tr>
                                                                    <tr class="h_isitable">
                                                                        <td class="text-center">7.</td>
                                                                        <td>NOMOR IJASAH/SERTIFIKAT</td>
                                                                        <td>{{data.no_ijazah}}</td>
                                                                    </tr>

                                                                </tbody>
                                                            </table>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>

                                            

                                        </div>



                                    </div>
                                </div>
                                <div class="modal-footer">
                                    <!-- <button type="submit" class="btn btn-success waves-effect">RUBAH</button> -->
                                    <button @click="emptyData()" type="button" class="btn btn-danger waves-effect" data-dismiss="modal">KEMBALI</button>
                                </div>
                            </div>
                        </div>
                    </div>
                <!-- xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx MODAL LIST PENDIDIKAN xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx -->

                <!-- xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx MODAL TAMBAH xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx -->
                    <div class="modal fade" id="m_tambah_data" tabindex="-1" role="dialog" data-backdrop="static">
                        <div class="modal-dialog modal-lg" role="document">
                            <div class="modal-content">
                                <div class="modal-header bg-light-blue">
                                    <button @click="emptyPendidikan()" type="button" class="close" data-dismiss="modal" aria-label="Close">
                                        <span aria-hidden="true">&times;</span></button>
                                    <h4 class="modal-title" id="largeModalLabel">TAMBAH DATA</h4>
                                </div>

                                <form @submit.prevent="addData()">
                                    <div class="modal-body">


                                            <span class="huruf_input">Scan Ijazah/Sertifikat</span>
                                            <input @change="onFileSelected"  type="file" class="form-control"  accept=".pdf"><br>

                                            <span class="huruf_input">Nama Diklat</span>
                                            <input type="text" v-model="pendidikan.nm_diklat" class="form-control" > <br>

                                            <span class="huruf_input">Tempat Belajar</span>
                                            <select v-model="pendidikan.tpt_belajar" class="form-control">
                                                <option>Dalam Negeri</option>
                                                <option>Luar Negeri</option>
                                            </select> <br>

                                            <div class="row">
                                                <div class="col-md-4">
                                                    <span class="huruf_input">Tgl Mulai</span>
                                                    <input v-model="pendidikan.tgl_mulai" type="date" class="form-control" >
                                                </div>
                                                <div class="col-md-4">
                                                    <span class="huruf_input">Tgl Selesai</span>
                                                    <input v-model="pendidikan.tgl_selesai" type="date" class="form-control" >
                                                </div>
                                                <div class="col-md-4">
                                                    <span class="huruf_input">Jml Jam</span>
                                                    <input v-model="pendidikan.jumlah_jam" type="number" class="form-control" >
                                                </div>
                                            </div><br>

                                            <span class="huruf_input">Lokasi Pendidikan</span>
                                            <input type="text" v-model="pendidikan.lokasi_pendidikan" class="form-control" ><br>

                                            <span class="huruf_input">Nomor Ijazah/Sertifikat</span>
                                            <input type="text" v-model="pendidikan.no_ijazah" class="form-control" ><br>


                                    </div>
                                    <div class="modal-footer">
                                        <button type="submit" class="btn btn-info waves-effect">SIMPAN</button>
                                        <button @click="emptyPendidikan()" type="button" class="btn btn-danger waves-effect" data-dismiss="modal">KEMBALI</button>
                                    </div>
                                </form>


                            </div>
                        </div>
                    </div>
                <!-- xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx MODAL TAMBAH xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx -->

                <!-- xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx MODAL EDIT xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx -->
                    <div class="modal fade" id="m_edit_data" tabindex="-1" role="dialog" data-backdrop="static">
                        <div class="modal-dialog modal-lg" role="document">
                            <div class="modal-content">
                                <div class="modal-header bg-light-green">
                                    <button @click="emptyPendidikan()" type="button" class="close" data-dismiss="modal" aria-label="Close">
                                        <span aria-hidden="true">&times;</span></button>
                                    <h4 class="modal-title" id="largeModalLabel">EDIT DATA</h4>
                                </div>
                                <form @submit.prevent="editData()">

                                <div class="modal-body">
                                    <span class="huruf_input">Scan Ijazah/Sertifikat</span>
                                            <input @change="onFileSelected"  type="file" class="form-control"  accept=".pdf"><br>

                                            <span class="huruf_input">Nama Diklat</span>
                                            <input type="text" v-model="pendidikan.nm_diklat" class="form-control" > <br>

                                            <span class="huruf_input">Tempat Belajar</span>
                                            <select v-model="pendidikan.tpt_belajar" class="form-control">
                                                <option>Dalam Negeri</option>
                                                <option>Luar Negeri</option>
                                            </select> <br>

                                            <div class="row">
                                                <div class="col-md-4">
                                                    <span class="huruf_input">Tgl Mulai</span>
                                                    <input v-model="pendidikan.tgl_mulai" type="date" class="form-control" >
                                                </div>
                                                <div class="col-md-4">
                                                    <span class="huruf_input">Tgl Selesai</span>
                                                    <input v-model="pendidikan.tgl_selesai" type="date" class="form-control" >
                                                </div>
                                                <div class="col-md-4">
                                                    <span class="huruf_input">Jml Jam</span>
                                                    <input v-model="pendidikan.jumlah_jam" type="number" class="form-control" >
                                                </div>
                                            </div><br>

                                            <span class="huruf_input">Lokasi Pendidikan</span>
                                            <input type="text" v-model="pendidikan.lokasi_pendidikan" class="form-control" ><br>

                                            <span class="huruf_input">Nomor Ijazah/Sertifikat</span>
                                            <input type="text" v-model="pendidikan.no_ijazah" class="form-control" ><br>

                                </div>
                                <div class="modal-footer">
                                    <button type="submit" class="btn btn-success waves-effect">RUBAH</button>
                                    <button @click="emptyPendidikan()" type="button" class="btn btn-danger waves-effect" data-dismiss="modal">KEMBALI</button>
                                </div>
                                </form>
                            </div>
                        </div>
                    </div>
                <!-- xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx MODAL EDIT xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx -->

                <!-- xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx MODAL LIHAT FILE xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx -->
                    <div class="modal fade" id="m_lihat_lampiran" tabindex="-1" role="dialog" data-backdrop="static">
                        <div class="modal-dialog modal-lg" role="document">
                            <div class="modal-content">
                                <div class="modal-header bg-light-blue">
                                    <button @click="emptyPendidikan()" type="button" class="close" data-dismiss="modal" aria-label="Close">
                                        <span aria-hidden="true">&times;</span></button>
                                    <h4 class="modal-title" id="largeModalLabel">DATA LAMPIRAN</h4>
                                </div>
                                <form @submit.prevent="editData()">

                                <div class="modal-body">
                                    <iframe :src="'http://docs.google.com/gview?url='+file_path+pendidikan.file+'&embedded=true'" style="width:100%; height:1000px;" frameborder="0"></iframe>
                                    <!-- <div class="text-center">
                                        <embed :src="file_path+pendidikan.file" width="850" height="800" 
                                        type="application/pdf">
                                    </div> -->

                                </div>
                                <div class="modal-footer">
                                    <button @click="emptyPendidikan()"  type="button" class="btn btn-danger waves-effect" data-dismiss="modal">KEMBALI</button>
                                </div>
                                </form>
                            </div>
                        </div>
                    </div>
                <!-- xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx MODAL LIHAT FILE xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx -->


            <!-- ============================================================ MODAL ======================================================================== -->




    <!-- ============================================================ MULAI ======================================================================== -->
        </div>

    </div>

    </div>
    </section>



</div>
</template>


<script>
import OrganizationChart from 'vue-organization-chart'
  import 'vue-organization-chart/dist/orgchart.css'


    const ADD_URL = URL_APP+'api/v1/simpeg_biodata/';
    const ADD_URL_UNIT_KERJA = URL_APP+'api/v1/simpeg_unit_kerja/';

    import Autocomplete from 'vue2-autocomplete-js'
    const URL_SERVER = URL_APP;
    const FILE_LOAD = URL_APP+'uploads/';
    const ADD_URL_PENDIDIKAN = URL_APP+'api/v1/simpeg_diklat_fungsional/';


    
    export default {
        name: "planning_kabupaten",
        components: { Autocomplete, OrganizationChart},
        
        data() {
            return {
                form : {
                    id : '',
                    nama : '',
                    nip : '',
                    gelar_depan : '',
                    gelar_belakang : '',
                    ttl : '',
                    tempat_lahir : '',
                    jenis_kelamin : '',
                    status_keluarga : '',
                    agama : '',
                    pendidikan_ahir : '',
                    sekolah : '',
                    thn_lulus : '',
                    tmt_cpns : '',
                    gol : '',
                    tmt_golongan : '',
                    jabatan : '',
                    tmt_jabatan : '',
                    no_karpeg : '',
                    taspen : '',
                    NPWP : '',
                    alamat : '',
                    kota_asal : '',
                    kode_pos : '',
                    kontak : '',
                    unit_kerja : '',
                    file : '',
                    
                },
                pendidikan : {
                    diklat_fungsional_id : '',
                    nm_diklat : '',
                    tpt_belajar : '',
                    lokasi_pendidikan : '',
                    tgl_mulai : '',
                    tgl_selesai : '',
                    jumlah_jam : 0,
                    no_ijazah : '',
                    file : '',
                    biodata_id : '',
                    userId : '',
                    createdAt : '',
                },
                list_strata : [],
                list_pendidikan : [],
                

                nm_jabatan : '',
                nm_unit_kerja : '',

                unit_kerja : '',
                unit_kerja_full : '',
                unit_kerja_edit : '',



                list_data: [],

                page_first : 1,
                page_last : 0,
                cari_value : '',

                token : localStorage.token,
                URL : URL_SERVER,

                cek_unit : false,
                cek_edit : false,
                file_path : FILE_LOAD,
                file_old : '',
                ds: {},
            };
        },

        mounted() {
            localStorage.sidemenu = 'simpeg';
            
            var get_profile = JSON.parse(localStorage.profile);
            this.unit_kerja_full = get_profile.profile.unit_kerja_nama;
            this.unit_kerja = get_profile.profile.unit_kerja;

            // this.form.unit_kerja = get_profile.profile.unit_kerja;

            this.getData();
        },

    // =============================================================== METHODS =========================================================================
        methods : {
            addData: function(){

                var formData = new FormData();

                formData.append('diklat_fungsional_id', this.pendidikan.diklat_fungsional_id);
                formData.append('nm_diklat', this.pendidikan.nm_diklat);
                formData.append('tpt_belajar', this.pendidikan.tpt_belajar);
                formData.append('lokasi_pendidikan', this.pendidikan.lokasi_pendidikan);
                formData.append('tgl_mulai', this.pendidikan.tgl_mulai);
                formData.append('tgl_selesai', this.pendidikan.tgl_selesai);
                formData.append('jumlah_jam', this.pendidikan.jumlah_jam);
                formData.append('no_ijazah', this.pendidikan.no_ijazah);
                formData.append('biodata_id', this.pendidikan.biodata_id);
                formData.append('file', this.pendidikan.file);

                fetch(ADD_URL_PENDIDIKAN+'createData', {
                    method: "POST",
                    headers: {
                        authorization : 'kikensbatara '+localStorage.token
                    },
                    body: formData
                }).then(res => res.json()).then((data_urusan) => {
                    this.alertku('success', 'Berhasil Menambah Data!');
                    this.getPendidikan();
                });
            },
            getData: function(){
                fetch(ADD_URL+'view', {
                    method : 'POST',
                    headers : {
                      "content-type": "application/json",
                      authorization: "kikensbatara " + localStorage.token
                    },
                    body : JSON.stringify({
                      data_ke : this.page_first,
                      cari_value : this.cari_value,
                      unit_kerja : this.form.unit_kerja

                    })
                }).then((res) => res.json()).then((datanya) => {
                  this.list_data = datanya.data;
                  this.page_last = datanya.jml_data;
                //   console.log(datanya);
                })
            },
            
            editData: function(){

                var formData = new FormData();
                formData.append('diklat_fungsional_id', this.pendidikan.diklat_fungsional_id);
                formData.append('nm_diklat', this.pendidikan.nm_diklat);
                formData.append('tpt_belajar', this.pendidikan.tpt_belajar);
                formData.append('lokasi_pendidikan', this.pendidikan.lokasi_pendidikan);
                formData.append('tgl_mulai', this.pendidikan.tgl_mulai);
                formData.append('tgl_selesai', this.pendidikan.tgl_selesai);
                formData.append('jumlah_jam', this.pendidikan.jumlah_jam);
                formData.append('no_ijazah', this.pendidikan.no_ijazah);
                formData.append('biodata_id', this.pendidikan.biodata_id);
                formData.append('file', this.pendidikan.file);
                formData.append('file_old', this.file_old);

                fetch(ADD_URL_PENDIDIKAN+'updateData', {
                    method: "POST",
                    headers: {
                        authorization : 'kikensbatara '+localStorage.token
                    },
                    body: formData
                }).then((res_data) => {
                    this.alertku("success", "Berhasil Mengubah Data!");
                    this.getPendidikan();
                });
            },
            selectData : function(data){
                console.log(data);
                this.form = {
                    id : data.id,
                    nama : data.nama,
                    nip : data.nip,
                    gelar_depan : data.gelar_depan,
                    gelar_belakang : data.gelar_belakang,
                    ttl : data.ttl,
                    tempat_lahir : data.tempat_lahir,
                    jenis_kelamin : data.jenis_kelamin,
                    status_keluarga : data.status_keluarga,
                    agama : data.agama,
                    pendidikan_ahir : data.pendidikan_ahir,
                    sekolah : data.sekolah,
                    thn_lulus : data.thn_lulus,
                    tmt_cpns : data.tmt_cpns,
                    gol : data.gol,
                    tmt_golongan : data.tmt_golongan,
                    jabatan : data.jabatan,
                    tmt_jabatan : data.tmt_jabatan,
                    no_karpeg : data.no_karpeg,
                    taspen : data.taspen,
                    NPWP : data.NPWP,
                    alamat : data.alamat,
                    kota_asal : data.kota_asal,
                    kode_pos : data.kode_pos,
                    kontak : data.kontak,
                    unit_kerja : data.unit_kerja,
                    file : data.file,
                };

                this.pendidikan.biodata_id = data.id;

                this.unit_kerja_edit = data.unit_kerja;

                this.cek_edit = true;
                this.nm_unit_kerja = data.nm_unit_kerja;
                this.nm_jabatan = data.nm_jabatan
                

                this.getStrata();
                this.getPendidikan();
            },

            
            removeData : function(idnya, file){
                this.$swal({
                  title: 'Apa Anda Ingin Menghapus Data?',
                  text: 'Data Yang Telah Dihapus Tidak Dapat Dikembalikan',
                  type: 'warning',
                  showCancelButton: true,
                  confirmButtonText: 'Ya',
                  cancelButtonText: 'Batal',
                  showCloseButton: true,
                  showLoaderOnConfirm: true
                }).then((result) => {
                  if(result.value) {
                    fetch(ADD_URL_PENDIDIKAN + "removeData", {
                        method: "POST",
                        headers: {
                            "content-type": "application/json",
                            authorization: "kikensbatara " + localStorage.token
                        },
                        body: JSON.stringify({
                            id: idnya,
                            file : file
                        })
                    }).then(res_data => {
                        this.getPendidikan();
                        this.alertku("success", "sukses menghapus data");
                        this.file_old = null;
                    });
                    this.$swal('Terhapus', 'Berhasil Menghapus Data!', 'success')
                  } else {
                    this.$swal('Batal', 'Batal Menghapus Data!', 'info')
                  }
                })
            },
            emptyData : function(){
                this.list_strata = [];
                this.list_pendidikan = [];
                this.cek_edit = false;
            },

        // ================== TAMBAHAN ====================
            check_add : function(){

            },

            getStrata: function(){
                fetch(ADD_URL+'getStrata', {
                    method : 'GET',
                    headers : {
                      "content-type": "application/json",
                      authorization: "kikensbatara " + localStorage.token
                    }
                }).then((res) => res.json()).then((res_data) => {
                  this.list_strata = res_data;
                })
            },
            getPendidikan: function(){
                fetch(ADD_URL_PENDIDIKAN+'view', {
                    method : 'POST',
                    headers : {
                      "content-type": "application/json",
                      authorization: "kikensbatara " + localStorage.token
                    },
                    body : JSON.stringify({
                      biodata_id : this.pendidikan.biodata_id,
                    })
                }).then((res) => res.json()).then((res_data) => {
                  this.list_pendidikan = res_data;
                  console.log(res_data);

                })


            },
            selectPendidikan: function(data){
                console.log(data);
                // var tgl_mulai1 = data.tgl_mulai
                // var tgl_mulai1 = data.tgl_mulai


                this.pendidikan = {
                    diklat_fungsional_id : data.diklat_fungsional_id,
                    nm_diklat : data.nm_diklat,
                    tpt_belajar : data.tpt_belajar,
                    lokasi_pendidikan : data.lokasi_pendidikan,
                    tgl_mulai : this.split_date(data.tgl_mulai),
                    tgl_selesai : this.split_date(data.tgl_selesai),
                    jumlah_jam : data.jumlah_jam,
                    no_ijazah : data.no_ijazah,
                    file : data.file,
                    biodata_id : data.biodata_id,
                    userId : data.userId,
                    createdAt : data.createdAt,
                };
                this.file_old = data.file;

            },
            emptyPendidikan : function(){
                this.pendidikan.file = '';
                this.file_old = '';
            },
            onFileSelected : function(event){
                this.pendidikan.file = event.target.files[0];
                // console.log(this.form.file);
            },
            check_gelar_depan : function(data){
                if (data == undefined || data == null || data == '') {
                    return ''
                } else {
                    return data+'. '
                }
            },
            check_gelar_belakang : function(data){
                if (data == undefined || data == null || data == '') {
                    return ''
                } else {
                    return ', '+data
                }
            },
            split_date : function(date){
                var date3 = date+1;
                var date2 = date3.split("T");
                var date1 = date2[0].split("-");
                // return date1[2]+"/"+date1[1]+"/"+date1[0];
                // return date2[0]
                return date
            },
        // ================== TAMBAHAN ====================



        // ================== AUTOCOMPLETE ====================
            renderChild(data) {
                return `
                <span><b>${data.unit_kerja}</b></span>
                <span style='font-size:80%'>${data.ref_instansi}</span>
                `
            },
            getAuto : function(obj){
                this.unit_kerja = obj.id;
                this.unit_kerja_full = obj.unit_kerja;
                this.form.unit_kerja = obj.id;
                this.cari_data();
                this.getData();
                // console.log(obj);
            },

            getAuto1 : function(obj){
                this.unit_kerja_edit= obj.id;
                // console.log(obj);
            },
        // ================== AUTOCOMPLETE ====================

        // ================== PAGINASI ====================
            alertku : function(type, title){
              this.$swal({
                type: type,
                title: title,
                showConfirmButton: false,
                timer: 800
              });
            },

            btn_prev : function(){
              if(this.page_first>1){
                this.page_first--
              }else{
                this.page_first = 1;
              }
              this.getData();
            },

            btn_next : function(){
              if(this.page_first >= this.page_last){
                this.page_first == this.page_last
              }else{
                this.page_first++;
              }
              this.getData();
            },

            cari_data : function(){
                this.page_first = 1;
                this.getData();
            }

        // ================== PAGINASI ====================

        },
    // =============================================================== METHODS =========================================================================

    };
</script>
